export const GET_ALL_DATA = "GET_ALL_DATA";